export function formatAIDuration(durationMs: number): string {
  const normalizedMs = Math.max(0, Math.round(durationMs));
  if (normalizedMs < 1000) return `${normalizedMs}ms`;

  const totalSeconds = Math.round(normalizedMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return [hours ? `${hours}h` : '', minutes ? `${minutes}m` : '']
      .filter(Boolean)
      .join(' ');
  }
  if (minutes > 0) {
    return `${minutes}m${seconds ? ` ${seconds}s` : ''}`;
  }
  return `${totalSeconds}s`;
}
